import { Plus } from 'lucide-react';
import type { MouseEvent } from 'react';
import type { SuggestionOption as SuggestionOptionValue } from './suggested-text-input.types';

const NEW_VALUE_LABEL = 'New value';

interface SuggestionOptionProps {
  id: string;
  option: SuggestionOptionValue;
  isActive: boolean;
  isSelected: boolean;
  onActivate: () => void;
  onSelect: () => void;
}

export function SuggestionOption({
  id,
  option,
  isActive,
  isSelected,
  onActivate,
  onSelect,
}: SuggestionOptionProps) {
  const { value, isNew } = option;
  const optionLabel = isNew ? `Use ${value} as a new value` : value;
  const handleMouseDown = (event: MouseEvent<HTMLLIElement>) => {
    event.preventDefault();
    onSelect();
  };

  return (
    <li
      id={id}
      role="option"
      aria-label={optionLabel}
      aria-selected={isSelected}
      data-active={isActive || undefined}
      data-new-value={isNew || undefined}
      onMouseDown={handleMouseDown}
      onMouseEnter={onActivate}>
      {isNew && <Plus aria-hidden />}
      <span>{value}</span>
      {isNew && <small>{NEW_VALUE_LABEL}</small>}
    </li>
  );
}
